export default __webpack_public_path__ + "assets/images/7bc1bba33408917e2b8bef6640779bf0.png";